<template>
    <div style="padding: 20px">

      <el-button class="mybtn-blue2" style="width: 100px" @click="addDialogVisible=true">设置</el-button>

      <hr>

      <el-row>
        <el-col :span="12">
          <div>
            <p class="subtitle">订单打印基本信息</p>
            <el-form label-width="130px">
              <el-form-item label="默认打印机：">
                <span>{{printer||'未设置'}}</span>
              </el-form-item>
              <el-form-item label="订单打印顺序：">
                <span>{{printOrder||'未设置'}}</span>
              </el-form-item>
              <el-form-item label="打印数量：">
                <span>{{printNum}}份/次</span>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>

      <!--dialog 新增-->
      <el-dialog title="设置打印机" :visible.sync="addDialogVisible" class="mydialog mydialog_add_order_group"
                 :append-to-body="true">
        <el-form :label-position="'right'" label-width="120px">
          <div style="margin-top: 20px">
            <el-form-item label="打印机：">
              <el-select size="small" v-model="printer">
                <el-option label="EPSON 610K A" value="EPSON 610K A"></el-option>
                <el-option label="EPSON 610K B" value="EPSON 610K B"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top: 20px">
            <el-form-item label="订单打印顺序：">
              <el-select size="small" value="下单立即自动打印" v-model="printOrder">
                <el-option label="下单立即自动打印" value="01"></el-option>
                <el-option label="订单审核后自动打印" value="02"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top: 20px">
            <el-form-item label="打印数量：">
              <el-input size="small" v-model="printNum" style="width: 240px"></el-input>
              <span> 份/次</span>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer">
          <el-button class="mybtn-blue2" @click="saveSetting()">保存</el-button>
          <el-button @click="addDialogVisible=false">取消</el-button>
        </div>
      </el-dialog>

    </div>
</template>

<script>
export default {
    data :function() {
        return {
            addDialogVisible: false,
            "printer": null,
            "printOrder": null,
            "printNum": null
        }
    },
    methods:{
        getSetting: function(){
            let self = this;
            self.xFetch.post(self.xApi('/robot/rule/autoprint/order/getSetting'), {}).then(function (res) {
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                self.printer = res.data.data.printer;
                self.printOrder = res.data.data.printOrder;
                self.printNum = res.data.data.printNum;
            });
        },
        saveSetting: function(){
            let self = this;
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi('/robot/rule/autoprint/order/saveSetting'), {
                printer:self.printer,
                printOrder:self.printOrder,
                printNum:self.printNum,
            }).then(function (res) {
                self.xEui.loading_close();
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else{
                    self.xEui.msg_success('保存成功')
                    self.addDialogVisible = false;
                }
            });
        }
    },
    created:function(){
        let self = this;

        // 加载配置
        self.getSetting();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  hr{
    margin: 20px 0;
    height:1px;
    border:none;
    border-top:1px solid #eeeeee;
  }
  .subtitle{
    font-size: 16px;
    font-weight: bold;
    margin-right: 20px;
  }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
</style>
<style>
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/print-order.vue